module.exports = __webpack_public_path__ + "img/ctrl-r-theta-stub-down--i.25407a92.svg";